import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './styles.css';

const root = document.getElementById('root');
if (root === null) throw new Error('The Current could not find its root element');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
